import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "col-lg-12" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Validation Form"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview-tab",
              tabindex: "0"
            }, [
              _createElementVNode("form", {
                class: "row g-3 needs-validation",
                novalidate: ""
              }, [
                _createElementVNode("div", { class: "col-md-6" }, [
                  _createElementVNode("label", {
                    for: "validationCustom01",
                    class: "form-label label text-secondary"
                  }, "First name"),
                  _createElementVNode("div", { class: "position-relative" }, [
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control h-55 ps-5",
                      id: "validationCustom01",
                      value: "Mark",
                      required: ""
                    }),
                    _createElementVNode("div", { class: "valid-feedback" }, "Looks good!"),
                    _createElementVNode("i", {
                      class: "ri-user-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20",
                      style: {"top":"13px !important"}
                    })
                  ])
                ]),
                _createElementVNode("div", { class: "col-md-6" }, [
                  _createElementVNode("label", {
                    for: "validationCustom02",
                    class: "form-label label text-secondary"
                  }, "Last name"),
                  _createElementVNode("div", { class: "position-relative" }, [
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control h-55 ps-5",
                      id: "validationCustom02",
                      value: "Otto",
                      required: ""
                    }),
                    _createElementVNode("div", { class: "valid-feedback" }, "Looks good!"),
                    _createElementVNode("i", {
                      class: "ri-user-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20",
                      style: {"top":"13px !important"}
                    })
                  ])
                ]),
                _createElementVNode("div", { class: "col-md-6" }, [
                  _createElementVNode("label", {
                    for: "validationCustom03",
                    class: "form-label label text-secondary"
                  }, "Email Address"),
                  _createElementVNode("div", { class: "position-relative" }, [
                    _createElementVNode("input", {
                      type: "email",
                      class: "form-control h-55 ps-5",
                      id: "validationCustom03",
                      value: "trezo@gmail.com",
                      required: ""
                    }),
                    _createElementVNode("div", { class: "valid-feedback" }, "Looks good!"),
                    _createElementVNode("i", {
                      class: "ri-mail-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20",
                      style: {"top":"13px !important"}
                    })
                  ])
                ]),
                _createElementVNode("div", { class: "col-md-6" }, [
                  _createElementVNode("label", {
                    for: "validationCustom04",
                    class: "form-label label text-secondary"
                  }, "Phone"),
                  _createElementVNode("div", { class: "position-relative" }, [
                    _createElementVNode("input", {
                      type: "number",
                      class: "form-control h-55 ps-5 text-dark",
                      id: "validationCustom04",
                      value: "+02071234567",
                      placeholder: "020 7123 4567",
                      required: ""
                    }),
                    _createElementVNode("div", { class: "valid-feedback" }, "Looks good!"),
                    _createElementVNode("i", {
                      class: "ri-phone-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20",
                      style: {"top":"13px !important"}
                    })
                  ])
                ]),
                _createElementVNode("div", { class: "col-md-12" }, [
                  _createElementVNode("label", {
                    for: "validationCustom05",
                    class: "form-label label text-secondary"
                  }, "Address"),
                  _createElementVNode("div", { class: "position-relative" }, [
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control h-55 ps-5",
                      id: "validationCustom05",
                      placeholder: "Your location",
                      required: ""
                    }),
                    _createElementVNode("div", { class: "invalid-feedback" }, " Please provide a valid Address. "),
                    _createElementVNode("i", {
                      class: "ri-map-pin-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20",
                      style: {"top":"13px !important"}
                    })
                  ])
                ]),
                _createElementVNode("div", { class: "col-md-4" }, [
                  _createElementVNode("label", {
                    for: "validationCustom06",
                    class: "form-label label text-secondary"
                  }, "Town/City"),
                  _createElementVNode("div", { class: "position-relative" }, [
                    _createElementVNode("select", {
                      class: "form-select form-control h-55 ps-5",
                      id: "validationCustom06",
                      required: ""
                    }, [
                      _createElementVNode("option", {
                        selected: "",
                        disabled: "",
                        value: ""
                      }, "Choose..."),
                      _createElementVNode("option", null, "California")
                    ]),
                    _createElementVNode("div", { class: "invalid-feedback" }, " Please select a valid Town/City. "),
                    _createElementVNode("i", {
                      class: "ri-building-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20",
                      style: {"top":"13px !important"}
                    })
                  ])
                ]),
                _createElementVNode("div", { class: "col-md-4" }, [
                  _createElementVNode("label", {
                    for: "validationCustom07",
                    class: "form-label label text-secondary"
                  }, "State"),
                  _createElementVNode("div", { class: "position-relative" }, [
                    _createElementVNode("select", {
                      class: "form-select form-control h-55 ps-5",
                      id: "validationCustom07",
                      required: ""
                    }, [
                      _createElementVNode("option", {
                        selected: "",
                        disabled: "",
                        value: ""
                      }, " South poal evenue state 4C "),
                      _createElementVNode("option", null, "Trezo")
                    ]),
                    _createElementVNode("div", { class: "invalid-feedback" }, " Please select a valid State. "),
                    _createElementVNode("i", {
                      class: "ri-building-4-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20",
                      style: {"top":"13px !important"}
                    })
                  ])
                ]),
                _createElementVNode("div", { class: "col-md-4" }, [
                  _createElementVNode("label", {
                    for: "validationCustom08",
                    class: "form-label label text-secondary"
                  }, "Zip Code"),
                  _createElementVNode("div", { class: "position-relative" }, [
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control h-55 ps-5",
                      id: "validationCustom08",
                      required: ""
                    }),
                    _createElementVNode("div", { class: "invalid-feedback" }, " Please provide a valid zip. "),
                    _createElementVNode("i", {
                      class: "ri-inbox-unarchive-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20",
                      style: {"top":"13px !important"}
                    })
                  ])
                ]),
                _createElementVNode("div", { class: "col-md-12" }, [
                  _createElementVNode("label", {
                    for: "validationCustom09",
                    class: "form-label label text-secondary"
                  }, "Order Notes :"),
                  _createElementVNode("div", { class: "position-relative" }, [
                    _createElementVNode("textarea", {
                      cols: "30",
                      rows: "5",
                      class: "form-control ps-5 py-3",
                      id: "validationCustom09",
                      placeholder: "Notes",
                      required: ""
                    }),
                    _createElementVNode("div", { class: "invalid-feedback" }, " Please provide a valid Notes. "),
                    _createElementVNode("i", {
                      class: "ri-sticky-note-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20",
                      style: {"top":"13px !important"}
                    })
                  ])
                ]),
                _createElementVNode("div", { class: "col-12" }, [
                  _createElementVNode("div", { class: "form-check" }, [
                    _createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      value: "",
                      id: "invalidCheck",
                      required: ""
                    }),
                    _createElementVNode("label", {
                      class: "form-check-label",
                      for: "invalidCheck"
                    }, " Agree to terms and conditions "),
                    _createElementVNode("div", { class: "invalid-feedback" }, " You must agree before submitting. ")
                  ])
                ]),
                _createElementVNode("div", { class: "col-12" }, [
                  _createElementVNode("button", {
                    class: "btn btn-primary fw-semibold text-white py-2 px-3",
                    type: "submit"
                  }, " Submit Form ")
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode"
                }, [
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<form class=\"row g-3 needs-validation\" novalidate>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-md-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <label for=\"validationCustom01\" class=\"form-label label text-secondary\">First name</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <input type=\"text\" class=\"form-control h-55 ps-5\" id=\"validationCustom01\" value=\"Mark\" required>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"valid-feedback\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                Looks good!"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <i class=\"ri-user-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20\" style=\"top: 13px !important;\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-md-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <label for=\"validationCustom02\" class=\"form-label label text-secondary\">Last name</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <input type=\"text\" class=\"form-control h-55 ps-5\" id=\"validationCustom02\" value=\"Otto\" required>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"valid-feedback\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                Looks good!"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <i class=\"ri-user-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20\" style=\"top: 13px !important;\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-md-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <label for=\"validationCustom03\" class=\"form-label label text-secondary\">Email Address</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <input type=\"email\" class=\"form-control h-55 ps-5\" id=\"validationCustom03\" value=\"trezo@gmail.com\" required>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"valid-feedback\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                Looks good!"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <i class=\"ri-mail-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20\" style=\"top: 13px !important;\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-md-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <label for=\"validationCustom04\" class=\"form-label label text-secondary\">Phone</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <input type=\"number\" class=\"form-control h-55 ps-5 text-dark\" id=\"validationCustom04\" value=\"+02071234567\" placeholder=\"020 7123 4567\" required>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"valid-feedback\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                Looks good!"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <i class=\"ri-phone-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20\" style=\"top: 13px !important;\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-md-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <label for=\"validationCustom05\" class=\"form-label label text-secondary\">Address</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <input type=\"text\" class=\"form-control h-55 ps-5\" id=\"validationCustom05\" placeholder=\"Your location\" required>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"invalid-feedback\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                Please provide a valid Address."),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <i class=\"ri-map-pin-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20\" style=\"top: 13px !important;\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-md-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <label for=\"validationCustom06\" class=\"form-label label text-secondary\">Town/City</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <select class=\"form-select form-control h-55 ps-5\" id=\"validationCustom06\" required>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <option selected disabled value=\"\">Choose...</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <option>California</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </select>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"invalid-feedback\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                Please select a valid Town/City."),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <i class=\"ri-building-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20\" style=\"top: 13px !important;\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-md-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <label for=\"validationCustom07\" class=\"form-label label text-secondary\">State</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <select class=\"form-select form-control h-55 ps-5\" id=\"validationCustom07\" required>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <option selected disabled value=\"\">South poal evenue state 4C</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <option>Trezo</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </select>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"invalid-feedback\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                Please select a valid State."),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <i class=\"ri-building-4-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20\" style=\"top: 13px !important;\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-md-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <label for=\"validationCustom08\" class=\"form-label label text-secondary\">Zip Code</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <input type=\"text\" class=\"form-control h-55 ps-5\" id=\"validationCustom08\" required>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"invalid-feedback\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                Please provide a valid zip."),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <i class=\"ri-inbox-unarchive-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20\" style=\"top: 13px !important;\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-md-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <label for=\"validationCustom09\" class=\"form-label label text-secondary\">Order Notes :</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <textarea cols=\"30\" rows=\"5\" class=\"form-control ps-5 py-3\" id=\"validationCustom09\" placeholder=\"Notes\" required></textarea>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"invalid-feedback\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                Please provide a valid Notes."),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <i class=\"ri-sticky-note-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20\" style=\"top: 13px !important;\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"form-check\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"invalidCheck\" required>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <label class=\"form-check-label\" for=\"invalidCheck\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                Agree to terms and conditions"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"invalid-feedback\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                You must agree before submitting."),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button class=\"btn btn-primary fw-semibold text-white py-2 px-3\" type=\"submit\">Submit Form</button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</form>"),
                  _createTextVNode("\n")
                ]),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-12" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Validation Schema With On Change"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab2",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview2-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code2-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTab2Content"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("form", {
                class: "row g-3 needs-validation",
                novalidate: ""
              }, [
                _createElementVNode("div", { class: "col-md-6" }, [
                  _createElementVNode("label", {
                    for: "validationCustom10",
                    class: "form-label label text-secondary"
                  }, "First name"),
                  _createElementVNode("div", { class: "position-relative" }, [
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control h-55",
                      id: "validationCustom10",
                      value: "Mark",
                      required: ""
                    }),
                    _createElementVNode("div", { class: "valid-feedback" }, "Looks good!")
                  ])
                ]),
                _createElementVNode("div", { class: "col-md-6" }, [
                  _createElementVNode("label", {
                    for: "validationCustom11",
                    class: "form-label label text-secondary"
                  }, "Last name"),
                  _createElementVNode("div", { class: "position-relative" }, [
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control h-55",
                      id: "validationCustom11",
                      value: "Otto",
                      required: ""
                    }),
                    _createElementVNode("div", { class: "valid-feedback" }, "Looks good!")
                  ])
                ]),
                _createElementVNode("div", { class: "col-md-6" }, [
                  _createElementVNode("label", {
                    for: "validationCustom12",
                    class: "form-label label text-secondary"
                  }, "Email Address"),
                  _createElementVNode("div", { class: "position-relative" }, [
                    _createElementVNode("input", {
                      type: "email",
                      class: "form-control h-55",
                      id: "validationCustom12",
                      value: "trezo@gmail.com",
                      required: ""
                    }),
                    _createElementVNode("div", { class: "valid-feedback" }, "Looks good!")
                  ])
                ]),
                _createElementVNode("div", { class: "col-md-6" }, [
                  _createElementVNode("label", {
                    for: "validationCustom13",
                    class: "form-label label text-secondary"
                  }, "Phone"),
                  _createElementVNode("div", { class: "position-relative" }, [
                    _createElementVNode("input", {
                      type: "number",
                      class: "form-control h-55 text-dark",
                      id: "validationCustom13",
                      value: "+02071234567",
                      placeholder: "020 7123 4567",
                      required: ""
                    }),
                    _createElementVNode("div", { class: "valid-feedback" }, "Looks good!")
                  ])
                ]),
                _createElementVNode("div", { class: "col-md-12" }, [
                  _createElementVNode("label", {
                    for: "validationCustom14",
                    class: "form-label label text-secondary"
                  }, "Address"),
                  _createElementVNode("div", { class: "position-relative" }, [
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control h-55",
                      id: "validationCustom14",
                      placeholder: "Your location",
                      required: ""
                    }),
                    _createElementVNode("div", { class: "invalid-feedback" }, " Please provide a valid Address. ")
                  ])
                ]),
                _createElementVNode("div", { class: "col-md-4" }, [
                  _createElementVNode("label", {
                    for: "validationCustom15",
                    class: "form-label label text-secondary"
                  }, "Town/City"),
                  _createElementVNode("div", { class: "position-relative" }, [
                    _createElementVNode("select", {
                      class: "form-select form-control h-55",
                      id: "validationCustom15",
                      required: ""
                    }, [
                      _createElementVNode("option", {
                        selected: "",
                        disabled: "",
                        value: ""
                      }, "Choose..."),
                      _createElementVNode("option", null, "California")
                    ]),
                    _createElementVNode("div", { class: "invalid-feedback" }, " Please select a valid Town/City. ")
                  ])
                ]),
                _createElementVNode("div", { class: "col-md-4" }, [
                  _createElementVNode("label", {
                    for: "validationCustom16",
                    class: "form-label label text-secondary"
                  }, "State"),
                  _createElementVNode("div", { class: "position-relative" }, [
                    _createElementVNode("select", {
                      class: "form-select form-control h-55",
                      id: "validationCustom16",
                      required: ""
                    }, [
                      _createElementVNode("option", {
                        selected: "",
                        disabled: "",
                        value: ""
                      }, " South poal evenue state 4C "),
                      _createElementVNode("option", null, "Trezo")
                    ]),
                    _createElementVNode("div", { class: "invalid-feedback" }, " Please select a valid State. ")
                  ])
                ]),
                _createElementVNode("div", { class: "col-md-4" }, [
                  _createElementVNode("label", {
                    for: "validationCustom17",
                    class: "form-label label text-secondary"
                  }, "Zip Code"),
                  _createElementVNode("div", { class: "position-relative" }, [
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control h-55",
                      id: "validationCustom17",
                      required: ""
                    }),
                    _createElementVNode("div", { class: "invalid-feedback" }, " Please provide a valid zip. ")
                  ])
                ]),
                _createElementVNode("div", { class: "col-md-12" }, [
                  _createElementVNode("label", {
                    for: "validationCustom18",
                    class: "form-label label text-secondary"
                  }, "Order Notes :"),
                  _createElementVNode("div", { class: "position-relative" }, [
                    _createElementVNode("textarea", {
                      cols: "30",
                      rows: "5",
                      class: "form-control py-3",
                      id: "validationCustom18",
                      placeholder: "Notes",
                      required: ""
                    }),
                    _createElementVNode("div", { class: "invalid-feedback" }, " Please provide a valid Notes. ")
                  ])
                ]),
                _createElementVNode("div", { class: "col-12" }, [
                  _createElementVNode("div", { class: "form-check" }, [
                    _createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      value: "",
                      id: "invalidCheck2",
                      required: ""
                    }),
                    _createElementVNode("label", {
                      class: "form-check-label",
                      for: "invalidCheck2"
                    }, " Agree to terms and conditions "),
                    _createElementVNode("div", { class: "invalid-feedback" }, " You must agree before submitting. ")
                  ])
                ]),
                _createElementVNode("div", { class: "col-12" }, [
                  _createElementVNode("button", {
                    class: "btn btn-primary fw-semibold text-white py-2 px-3",
                    type: "submit"
                  }, " Submit Form ")
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode2"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode2"
                }, [
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<form class=\"row g-3 needs-validation\" novalidate>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-md-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <label for=\"validationCustom10\" class=\"form-label label text-secondary\">First name</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <input type=\"text\" class=\"form-control h-55\" id=\"validationCustom10\" value=\"Mark\" required>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"valid-feedback\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                Looks good!"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-md-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <label for=\"validationCustom11\" class=\"form-label label text-secondary\">Last name</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <input type=\"text\" class=\"form-control h-55\" id=\"validationCustom11\" value=\"Otto\" required>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"valid-feedback\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                Looks good!"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-md-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <label for=\"validationCustom12\" class=\"form-label label text-secondary\">Email Address</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <input type=\"email\" class=\"form-control h-55\" id=\"validationCustom12\" value=\"trezo@gmail.com\" required>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"valid-feedback\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                Looks good!"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-md-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <label for=\"validationCustom13\" class=\"form-label label text-secondary\">Phone</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <input type=\"number\" class=\"form-control h-55 text-dark\" id=\"validationCustom13\" value=\"+02071234567\" placeholder=\"020 7123 4567\" required>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"valid-feedback\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                Looks good!"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-md-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <label for=\"validationCustom14\" class=\"form-label label text-secondary\">Address</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <input type=\"text\" class=\"form-control h-55\" id=\"validationCustom14\" placeholder=\"Your location\" required>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"invalid-feedback\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                Please provide a valid Address."),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-md-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <label for=\"validationCustom15\" class=\"form-label label text-secondary\">Town/City</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <select class=\"form-select form-control h-55\" id=\"validationCustom15\" required>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <option selected disabled value=\"\">Choose...</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <option>California</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </select>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"invalid-feedback\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                Please select a valid Town/City."),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-md-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <label for=\"validationCustom16\" class=\"form-label label text-secondary\">State</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <select class=\"form-select form-control h-55\" id=\"validationCustom16\" required>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <option selected disabled value=\"\">South poal evenue state 4C</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <option>Trezo</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </select>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"invalid-feedback\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                Please select a valid State."),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-md-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <label for=\"validationCustom17\" class=\"form-label label text-secondary\">Zip Code</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <input type=\"text\" class=\"form-control h-55\" id=\"validationCustom17\" required>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"invalid-feedback\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                Please provide a valid zip."),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-md-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <label for=\"validationCustom18\" class=\"form-label label text-secondary\">Order Notes :</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <textarea cols=\"30\" rows=\"5\" class=\"form-control py-3\" id=\"validationCustom18\" placeholder=\"Notes\" required></textarea>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"invalid-feedback\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                Please provide a valid Notes."),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"form-check\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"invalidCheck2\" required>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <label class=\"form-check-label\" for=\"invalidCheck2\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                Agree to terms and conditions"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"invalid-feedback\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                You must agree before submitting."),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button class=\"btn btn-primary fw-semibold text-white py-2 px-3\" type=\"submit\">Submit Form</button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</form>"),
                  _createTextVNode("\n")
                ]),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ])))
}